<template>
  <div>
    <a-modal
      title="支付二维码"
      :visible="visible"
      width="400px"
      :maskClosable="false"
      :confirm-loading="confirmLoading"
      :footer="null"
      @ok="handleOk"
      @cancel="handleCancel"
    >
        <span class="qrcodeContent">微信扫描下方二维码完成支付</span>
        <span class="qrcodeContent orderTitle">{{orderData.orderName}}</span>
        <div class="qrcodeContent qrcode" id="qrcode" ref="qrCodeUrl" v-show="orderStatus == 'waitingPay'"></div>
        <div class="qrcodeContent qrcode paySuccess" v-show="orderStatus == 'paySuccess'">
            <img :src="paySuccessImg"/>
        </div>
        <span class="qrcodeContent">
            <span v-show="orderStatus == 'waitingPay'" class="reayPay">应付金额:￥{{orderData.totalAmount}}</span><span class="oldAmont" v-if="orderData.totalAmount != orderData.oldAmount"><s>￥{{orderData.oldAmount}}</s></span>
            <span v-show="orderStatus == 'paySuccess'" class="reayPay paySuccessText">支付成功</span>
        </span>
    </a-modal>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data () {
    return {
      visible: false,
      confirmLoading: false,
      orderData: {
        orderName: null,
        totalAmount: 0,
        oldAmount: 0,
        qrCode: null
      },
      orderStatus: 'waitingPay', // 订单状态, waitingPay: 待支付  paySuccess：支付成功
      timer: null, // 轮询订单状态的定时器
      paySuccessImg: require('../../../assets/paySuccess.png')
    }
  },
  methods: {
    show (orderData) {
      this.orderData = orderData
      this.orderStatus = 'waitingPay'
      this.visible = true
      this.creatQrCode()
    },
    creatQrCode () {
      setTimeout(() => {
      // 先清空原内容在渲染新的二维码，否则会重复出现多个二维码
        document.getElementById('qrcode').innerHTML = ''
        if (this.orderData && this.orderData.qrCode != null) {
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: this.orderData.qrCode,
            width: 130,
            height: 130,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
          console.log(qrcode)
          this.startOrderStatausTimes()
        }
      })
    },
    // 轮询请求订单状态
    startOrderStatausTimes () {
      this.destoryTimer()
      this.timer = setInterval(this.queryOrderStatus, 1000)
    },
    destoryTimer () {
      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    queryOrderStatus () {
      let valData = {
        orderNumber: this.orderData.orderNumber,
        orderType: this.orderData.orderType
      }
      this.$api.join.queryOrderStatus(valData).then(res => {
        if (res.status == 0) {
          var orderStatus = res.data
          if (orderStatus == 1) {
            this.orderStatus = 'paySuccess'
            this.destoryTimer()
            this.$emit('paySuccess')
          } else {
            this.orderStatus = 'waitingPay'
          }
        }
      }).catch(err => {
        console.log(err)
      })
    },
    handleOk (e) {
      this.ModalText = 'The modal will be closed after two seconds'
      this.confirmLoading = true
      setTimeout(() => {
        this.visible = false
        this.confirmLoading = false
      }, 2000)
    },
    handleCancel (e) {
      this.destoryTimer()
      this.visible = false
    }
  }
}
</script>
<style lang="scss" scoped>
.qrcodeContent{
  display: flex;
  align-content: center;
  justify-content: center;
  margin:0 auto;
}
.qrcode {
  margin-top: 10px;
  margin-bottom: 10px;
}
.orderTitle {
  font-size: 18px;
  color: #a80000;
}
.reayPay {
  font-size: 24px;
  color: #a80000;
}
.paySuccessText {
  font-size: 24px;
  color: #64e1b9;
}
.paySuccess {
  width: 130px;
}
.oldAmont {
  color: gray;
  margin-top: 10px;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/pay/PayQrCode.vue